import { useState, useEffect, useContext } from "react";
import { getUsersForSchool } from "../../api/userService";
import Layout from "../../components/Layout/Layout";
import UserContext from "../../context/UserContext";
import ClassStats from "../../components/ClassStats/ClassStats";
import IndividualStats from "../../components/IndividualStats/IndividualStats";
import { useLocation } from "react-router-dom";
import "./StatsPage.scss";

const StatsPage = () => {
  const { user } = useContext(UserContext);
  const [schoolChildren, setSchoolChildren] = useState([]);

  const location = useLocation();
  const pupilData = location.state;

  const getSchoolChildren = async () => {
    if (user.isAdmin) {
      setSchoolChildren(await getUsersForSchool(user.schoolId));
    }
  };

  useEffect(() => {
    getSchoolChildren();
  }, [user]);

  return (
    <Layout requiresAuth={true}>
      <section className="stats-page">
        <h1>Stats</h1>

        <div className="stats-page__content">
          {user.isAdmin ? (
            (pupilData && <IndividualStats pupilData={pupilData} />) || (
              <ClassStats schoolChildren={schoolChildren} />
            )
          ) : (
            <IndividualStats />
          )}
        </div>
      </section>
    </Layout>
  );
};

export default StatsPage;
